// extracted by mini-css-extract-plugin
module.exports = {"client-requirements":"ClientPreferencesView_client-requirements__3AGlE","conflicted":"ClientPreferencesView_conflicted__1QLBd"};